import type { CategoryDropdownOption } from "app/pages/sales-intelligence/sub-modules/signals/components/filters/SignalNewsFilter/types/CategoryDropdownOption";
import {
    buildItemsFromOptions,
    buildSelectedItemsFromFilter,
    mapNewsCategoriesToOptionsWithType,
} from "app/pages/sales-intelligence/sub-modules/signals/components/filters/SignalNewsFilter/utils/dropdownOptions";
import type { NewsCategoriesByType } from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsCategoriesByType";
import type { NewsCategory } from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsCategory";
import type { NewsCategoryType } from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsCategoryType";
import { useMemo } from "react";

type ReturnValue = {
    selectedValueWithCategories: readonly (NewsCategory | NewsCategoryType)[];
    optionsWithCategories: readonly CategoryDropdownOption[];
};

const useOptionsWithParentCategories = (
    selectedValue: readonly NewsCategory[],
    options: NewsCategoriesByType,
): ReturnValue => {
    return useMemo(() => {
        const optionsWithCategoryType = mapNewsCategoriesToOptionsWithType(options);

        return {
            selectedValueWithCategories: buildSelectedItemsFromFilter(selectedValue, optionsWithCategoryType),
            optionsWithCategories: buildItemsFromOptions(optionsWithCategoryType),
        };
    }, [options, selectedValue]);
};

export default useOptionsWithParentCategories;
